import {useCallback, useRef} from 'react';
import {useLazyGetFelicityPassQuery} from '../../api/services/felicityService';

const RENEW_BEFORE_MS = 2 * 60 * 1000;

const useFelicityPass = () => {
    const [fetchPass] = useLazyGetFelicityPassQuery();
    const held = useRef(null);

    return useCallback(async () => {
        const current = held.current;

        if (current && current.expiresAt - RENEW_BEFORE_MS > Date.now()) {
            return current.pass;
        }

        try {
            const result = await fetchPass().unwrap();

            if (!result?.pass) {
                held.current = null;

                return '';
            }

            held.current = {pass: result.pass, expiresAt: new Date(result.expiresAt).getTime()};

            return result.pass;
        } catch {
            held.current = null;

            return '';
        }
    }, [fetchPass]);
};

export default useFelicityPass;
